import React, { useState } from "react";
import Supplychain from "../../contracts/SupplyChain.json";
import Web3 from "web3";
import { Container, Row, Col, Card, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
function AdminResources() {
  let id = 0;
  const [amt, setAmt] = useState(0);
  const [buyamt, setBuyamt] = useState(0);

  async function start(event) {
    event.preventDefault();
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Supplychain.networks[networkId];
    const instance = new web3.eth.Contract(
      Supplychain.abi,
      deployedNetwork && deployedNetwork.address
    );
    console.log(accounts[0]);
    await instance.methods
      .makeMedicine(
        id,
        accounts[0],
        "Bharat Biotech Factory",
        "COVAXIN factory",
        "temp",
        "temp",
        "COVAXIN"
      )
      .send({ from: accounts[0] });
  }

  async function pack(event) {
    event.preventDefault();
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Supplychain.networks[networkId];
    const instance = new web3.eth.Contract(
      Supplychain.abi,
      deployedNetwork && deployedNetwork.address
    );
    await instance.methods.packMedicine(id).send({ from: accounts[0] });
  }
  async function sell(event) {
    event.preventDefault();
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Supplychain.networks[networkId];
    const instance = new web3.eth.Contract(
      Supplychain.abi,
      deployedNetwork && deployedNetwork.address
    );
    console.log(amt);
    await instance.methods.sellMedicine(id, amt).send({ from: accounts[0] });
  }

  async function buy(event) {
    event.preventDefault();
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Supplychain.networks[networkId];
    const instance = new web3.eth.Contract(
      Supplychain.abi,
      deployedNetwork && deployedNetwork.address
    );
    console.log(buyamt);
    await instance.methods
      .buyMedicine(id)
      .send({ from: accounts[0], value: buyamt });
  }
  async function ship(event) {
    event.preventDefault();
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Supplychain.networks[networkId];
    const instance = new web3.eth.Contract(
      Supplychain.abi,
      deployedNetwork && deployedNetwork.address
    );
    await instance.methods.shipMedicine(id).send({ from: accounts[0] });
  }
  async function receive(event) {
    event.preventDefault();
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Supplychain.networks[networkId];
    const instance = new web3.eth.Contract(
      Supplychain.abi,
      deployedNetwork && deployedNetwork.address
    );
    await instance.methods.receiveMedicine(id).send({ from: accounts[0] });
  }

  // async function purchase(event) {
  // 	event.preventDefault();
  // 	const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
  // 	const accounts = await web3.eth.getAccounts();
  // 	const networkId = await web3.eth.net.getId();
  // 	const deployedNetwork = Supplychain.networks[networkId];
  // 	const instance = new web3.eth.Contract(Supplychain.abi, deployedNetwork && deployedNetwork.address);
  // 	await instance.methods.purchaseMedicine(id).send({ from: accounts[0] });
  // }

  return (
    <div className="container container-fluid login-conatiner">
      <div style={{ padding: "5px" }}>
        <div className="d-flex flex-row btn btn-dark btn-lg btn-block">
          <Link to="/admin/home">
            <Button variant="secondary">Home</Button>
          </Link>{" "}
          <Link
            style={{ color: "white", marginLeft: "990px" }}
            to="/admin/supplychain"
          >
            <Button variant="secondary">View the Supply Chain</Button>
          </Link>{" "}
        </div>
      </div>
      <div className="container container-fluid login-conatiner">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>ACTION</th>
              <th>PRESS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Start the supply chain:</td>
              <td>
                <Button variant="btn btn-dark" onClick={start}>
                  Start
                </Button>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td> Manufacturer sends it for packing:</td>
              <td>
                <Button variant="btn btn-dark" onClick={pack}>
                  Pack
                </Button>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td> Manufacturer sends it for selling:</td>
              <td>
                <input
                  type="number"
                  onChange={(event) => setAmt(Number(event.target.value))}
                />
                <Button
                  style={{ marginLeft: "5px" }}
                  variant="btn btn-dark"
                  onClick={sell}
                >
                  Sell
                </Button>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td> Distributor buys it from the manufacturer:</td>
              <td>
                <input
                  type="number"
                  onChange={(event) => setBuyamt(Number(event.target.value))}
                />
                <Button
                  style={{ marginLeft: "5px" }}
                  variant="btn btn-dark"
                  onClick={buy}
                >
                  Buy
                </Button>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td> Distributor sends it for shipping:</td>
              <td>
                <Button variant="btn btn-dark" onClick={ship}>
                  Ship
                </Button>
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td> Hospital Admin receives it from the Distributor:</td>
              <td>
                <Button variant="btn btn-dark" onClick={receive}>
                  Recieve
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <Card
        className="text-center"
        style={{
          marginTop: "30px",
          marginBottom: "40px",
          marginLeft: "auto",
          marginRight: "auto",
          width: "400px",
          boxShadow: "0px 4px 10px",
        }}
      ></Card>
    </div>
  );
}

export default AdminResources;
